import { GraphQLFieldConfig, GraphQLNonNull, GraphQLID } from 'graphql'
import { Context } from '../shared'
import {
  TeamserverPreference,
  teamserverPreferenceType
} from '../types/teamserver-preference'

export const teamserverPreference: GraphQLFieldConfig<
  any,
  Context,
  {
    readonly preferenceID: string
  }
> = {
  type: new GraphQLNonNull(teamserverPreferenceType),
  description: 'Teamserver preference',
  args: {
    preferenceID: {
      description: 'The unique name ID for the Teamserver preference',
      type: new GraphQLNonNull(GraphQLID)
    }
  },
  async resolve(
    _source,
    { preferenceID },
    context
  ): Promise<TeamserverPreference> {
    const { preference } = await context.connector.get(
      `teamserver/preference?name=${preferenceID}`
    )

    return {
      id: preference && preference.name,
      value: preference && preference.value
    }
  }
}
